import { SessionStorage } from '@/lib/session-storage/session-storage';

type Extras = {
  phoneConditionDate?: string;
  phoneConditionSignature?: string;
  smsOptIn?: boolean;
};

export class AnalyticsExtras {
  static #instance?: AnalyticsExtras;

  #sessionStorage: SessionStorage;
  #extras: Extras;

  constructor(sessionStorage: SessionStorage) {
    this.#sessionStorage = sessionStorage;
    this.#extras = {};
  }

  static get() {
    if (!this.#instance) {
      this.#instance = new AnalyticsExtras(new SessionStorage());
    }
    return this.#instance;
  }

  get phoneConditionDate(): string | undefined {
    if (this.#extras.phoneConditionDate == null) {
      this.#extras.phoneConditionDate =
        this.#sessionStorage.getString('phoneConditionDate');
    }
    return this.#extras.phoneConditionDate;
  }

  set phoneConditionDate(value: string) {
    this.#extras.phoneConditionDate = value;
    this.#sessionStorage.setString('phoneConditionDate', value);
  }

  get phoneConditionSignature(): string | undefined {
    if (this.#extras.phoneConditionSignature == null) {
      this.#extras.phoneConditionSignature = this.#sessionStorage.getString(
        'phoneConditionSignature',
      );
    }
    return this.#extras.phoneConditionSignature;
  }

  set phoneConditionSignature(value: string) {
    this.#extras.phoneConditionSignature = value;
    this.#sessionStorage.setString('phoneConditionSignature', value);
  }

  get smsOptIn(): boolean | undefined {
    if (this.#extras.smsOptIn == null) {
      this.#extras.smsOptIn = this.#sessionStorage.getBoolean('smsOptIn');
    }
    return this.#extras.smsOptIn;
  }

  set smsOptIn(value: boolean) {
    this.#extras.smsOptIn = value;
    this.#sessionStorage.setBoolean('smsOptIn', value);
  }
}
